import { useQuery } from "@tanstack/react-query";
import { usePublicApiClient } from "../../hooks/usePublicApiClient";
import { ClaimsService } from "../motalvip-apis/generated";
import { QueryKey } from ".";

export const usePublicClaimDetailQuery = (params: Parameters<ClaimsService['getPublicClaimDetail']>[0], enabled: boolean) => {
    const backendApiClient = usePublicApiClient();
    return useQuery({
        queryKey: [QueryKey.CLAIM, 'claims', params.claimNo],
        queryFn: () => backendApiClient.publicClient.claims.getPublicClaimDetail(params),
        enabled: enabled,
    });
};